import { useSeo } from "@/lib/seo";
import { useLang } from "@/lib/i18n";
import { LEGAL, LEGAL_DATE } from "@/lib/legal";

const TITLE = { privacy: "privacy", cookies: "cookies_policy", terms: "terms", delivery: "delivery_returns" };

export default function Legal({ doc }) {
  const { t, lang } = useLang();
  useSeo({ title: t(TITLE[doc]), description: t("seo_home_desc") });
  const d = (LEGAL[lang] || LEGAL.lt)[doc];
  return (
    <div data-testid={`legal-page-${doc}`} className="mx-auto max-w-3xl px-4 sm:px-6 py-12">
      <div className="text-xs font-mono-x uppercase tracking-[0.25em] text-orange-500">// {t("legal_updated")} {LEGAL_DATE}</div>
      <h1 className="font-display font-black uppercase text-4xl sm:text-5xl tracking-tight mt-4">{t(TITLE[doc])}</h1>
      <p className="text-slate-300 mt-6 leading-relaxed">{d.intro}</p>
      <div className="mt-10 space-y-8">
        {d.sections.map(([h, p], i) => (
          <section key={h} className="border-l-2 border-[#3B4157] pl-5">
            <h2 className="font-display font-bold uppercase text-base md:text-lg"><span className="text-orange-500 font-mono-x mr-2">{String(i + 1).padStart(2, "0")}</span>{h}</h2>
            <p className="text-sm text-slate-400 mt-2 leading-relaxed">{p}</p>
          </section>
        ))}
      </div>
    </div>
  );
}
